
import React, { Fragment, useState } from 'react'
import { ListGroup } from 'react-bootstrap'

import { useProgrammation } from '@/Hooks/UseProgrammation'
import useTranslation from '@/Hooks/UseTranslation'

import ContentBlock from '../../components/ContentBlock'
import RelationsCreator from './RelationsCreator'
import RelationItem from './RelationItem'

import './Relations.scss'
import RelationEditor from './RelationEditor'

const Relations = () => {

  const { t } = useTranslation()

  const { itemOpened } = useProgrammation()

  const [ relation, setRelation ] = useState(null)

  console.log('relation', relation)

  return (
    <Fragment>
      <ContentBlock
        title={t('PROGRAMMATION_MANAGER:SectionRelationsTitle') + ` (${itemOpened.relations.length})`}
        collapsable
        isCollapsed={!itemOpened.relations.length}
      >
        <div style={{ textAlign: 'right' }}>
          <RelationsCreator />
        </div>
        {itemOpened.relations.length > 0 && (
          <ListGroup style={{ marginTop: '.5rem'}}>
            {itemOpened.relations.map((r: any, i: number) => (
              <RelationItem key={i}
                item={r}
                onSelect={() => setRelation(r)}
              />
            ))}
          </ListGroup>
        )}
      </ContentBlock>

      <RelationEditor
        relation={relation}
        onClose={() => setRelation(null)}
      />
    </Fragment>
  )
}

export default Relations